module.exports = __webpack_public_path__ + "img/neonwallet.f1970778.png";